"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THEME_COLOR_NOT_FOUND = exports.MUSIC_NOT_RENDERED = exports.CLIP_NOT_RENDERED = exports.CLIP_NOT_FOUND = exports.PHOTO_DATA_MISSING = exports.CLIPS_DATA_MISSING = exports.INVALID_REQUEST = exports.CAPTION_IS_NOT_OUTRO = exports.DUPLICATE_CAPTION_NOT_FOUND = exports.ANIMATION_NOT_RENDERED = exports.ANIMATION_NOT_VALID = exports.TEXT_STYLE_NOT_FOUND = exports.CAPTION_NOT_FOUND = exports.TEMPLATE_NOT_INCLUDE_IMAGE = exports.TEMPLATE_NOT_FOUND = exports.PROMO_MUSIC_DATA_MISSING = exports.PROMO_PHOTO_DATA_MISSING = exports.PROMO_VIDEO_DATA_MISSING = exports.DECORATION_DATA_MISSING = exports.INVALID_PARMS = void 0;
const INVALID_PARMS = 'invalid parms';
exports.INVALID_PARMS = INVALID_PARMS;
const DECORATION_DATA_MISSING = 'decoration data missing';
exports.DECORATION_DATA_MISSING = DECORATION_DATA_MISSING;
const PROMO_VIDEO_DATA_MISSING = 'promo video data missing';
exports.PROMO_VIDEO_DATA_MISSING = PROMO_VIDEO_DATA_MISSING;
const PROMO_PHOTO_DATA_MISSING = 'promo photo data missing';
exports.PROMO_PHOTO_DATA_MISSING = PROMO_PHOTO_DATA_MISSING;
const PROMO_MUSIC_DATA_MISSING = 'promo music data missing';
exports.PROMO_MUSIC_DATA_MISSING = PROMO_MUSIC_DATA_MISSING;
const TEMPLATE_NOT_FOUND = 'template not found';
exports.TEMPLATE_NOT_FOUND = TEMPLATE_NOT_FOUND;
const TEMPLATE_NOT_INCLUDE_IMAGE = 'template not found';
exports.TEMPLATE_NOT_INCLUDE_IMAGE = TEMPLATE_NOT_INCLUDE_IMAGE;
const CAPTION_NOT_FOUND = 'caption not found in data';
exports.CAPTION_NOT_FOUND = CAPTION_NOT_FOUND;
const TEXT_STYLE_NOT_FOUND = 'text style not found in caption children';
exports.TEXT_STYLE_NOT_FOUND = TEXT_STYLE_NOT_FOUND;
const ANIMATION_NOT_VALID = 'Animation name is not valid';
exports.ANIMATION_NOT_VALID = ANIMATION_NOT_VALID;
const ANIMATION_NOT_RENDERED = 'JS Animation not rendered';
exports.ANIMATION_NOT_RENDERED = ANIMATION_NOT_RENDERED;
const DUPLICATE_CAPTION_NOT_FOUND = 'caption to duplicate not found in decoration data';
exports.DUPLICATE_CAPTION_NOT_FOUND = DUPLICATE_CAPTION_NOT_FOUND;
const CAPTION_IS_NOT_OUTRO = 'caption is not outro';
exports.CAPTION_IS_NOT_OUTRO = CAPTION_IS_NOT_OUTRO;
const INVALID_REQUEST = 'invalid request';
exports.INVALID_REQUEST = INVALID_REQUEST;
const CLIPS_DATA_MISSING = 'clips data missing';
exports.CLIPS_DATA_MISSING = CLIPS_DATA_MISSING;
const PHOTO_DATA_MISSING = 'photo data missing';
exports.PHOTO_DATA_MISSING = PHOTO_DATA_MISSING;
const CLIP_NOT_FOUND = 'clip not found in data';
exports.CLIP_NOT_FOUND = CLIP_NOT_FOUND;
const CLIP_NOT_RENDERED = 'vide clip not rendered';
exports.CLIP_NOT_RENDERED = CLIP_NOT_RENDERED;
const MUSIC_NOT_RENDERED = 'music track not rendered';
exports.MUSIC_NOT_RENDERED = MUSIC_NOT_RENDERED;
const THEME_COLOR_NOT_FOUND = 'theme color not found';
exports.THEME_COLOR_NOT_FOUND = THEME_COLOR_NOT_FOUND;